module.exports = __webpack_public_path__ + "static/media/1988_maleRate_femaleRate.242b9ffe.png";